// Data for Past Gigs since 2016
export const pastGigs = [
  {
    id: "som-sept26",
    date: "06.09.26",
    name: "VINYL SELECTION @ SOM",
    image: "img/past_gigs/2026-06-09-som.jpg",
    raw_date: "2026-06-09",
  },
  {
    id: "imperdible-aug26",
    date: "22.08.26",
    name: "VINYL SELECTION @ IMPERDIBLE",
    image: "img/past_gigs/2026-22-08-imperdible.jpg",
    raw_date: "2026-22-08",
  },
  {
    id: "culkin-aug26",
    date: "16.08.26",
    name: "Vinyl Selection @ Culkin",
    image: "img/past_gigs/2026-16-08-culkin.jpg",
    raw_date: "2026-08-16",
  },
  {
    id: "salvadiscos-aug26",
    date: "14.08.26",
    name: "Salvadiscos w/ friends",
    image: "img/past_gigs/2026-14-08-salvadiscos.jpg",
    raw_date: "2026-08-14",
  },
  {
    id: "jac-apr26",
    date: "02.08.26",
    name: "JA\u00c7 CAF\u00c8",
    image: "img/past_gigs/2026-03-04-jac-cafe-vinyl-sessions_barcelona.jpg",
    raw_date: "2026-02-08",
  },
  {
    id: "amateur-july26",
    date: "31.07.26",
    name: "VINYL SELECTION @ AMATEUR",
    image: "img/past_gigs/2026-07-31_amateur-vinyl-sessions_barcelona_v2.jpeg",
    raw_date: "2026-31-07",
  },
  {
    id: "fonik-cafe-june26",
    date: "17.06.26",
    name: "VINYL SELECTION @ FONIK CAFÉ",
    image: "img/past_gigs/2026-17-06-fonik-cafe.jpg",
    raw_date: "2026-25-06",
  },
  {
    id: "barra-oso-june26",
    date: "25.06.26",
    name: "VINYL SELECTION @ BARRA OSO",
    image: "img/past_gigs/2026-06-25-barraoso.jpg",
    raw_date: "2026-25-06",
  },
  {
    id: "imperdible-june26",
    date: "06.06.26",
    name: "VINYL SELECTION @ IMPERDIBLE",
    image: "img/past_gigs/2026-06-06-imperdible.jpg",
    raw_date: "2026-06-06",
  },
  {
    id: "berlin-club-may26",
    date: "29.05.26",
    name: "PAMPA W/ PABELS & PANDO @ CAFÉ BERLIN",
    image: "img/past_gigs/2026-05-29_berlin-club-pabels.jpg",
    raw_date: "2026-05-29",
  },
  {
    id: "amateur-may26",
    date: "22.05.26",
    name: "Amateur BCN",
    image: "img/past_gigs/2026-05-22_amateur-vinyl-sessions_barcelona.jpg",
    raw_date: "2026-05-22",
  },
  {
    id: "alocasia-may26",
    date: "09.05.26",
    name: "Alocasia TV @ SOM CAFÈ",
    image: "img/past_gigs/2026-09-05-alocasia-som-cafe-barcelona.jpg",
    raw_date: "2026-05-09",
  },
  {
    id: "amateur-apr26",
    date: "17.04.26",
    name: "Amateur BCN",
    image: "img/past_gigs/2026-04-17_amateur-vinyl-sessions_barcelona.jpg",
    raw_date: "2026-04-17",
  },
  {
    id: "jac-apr26",
    date: "03.04.26",
    name: "JA\u00c7 CAF\u00c8",
    image: "img/past_gigs/2026-03-04-jac-cafe-vinyl-sessions_barcelona.jpg",
    raw_date: "2026-03-04",
  },
  {
    id: "salvadiscos-blackie-friends-dec25",
    date: "04.12.25",
    name: "Blackie & Friends @ Salvadiscos BCN",
    image: "img/past_gigs/2025-12-04-past-gig-salvadicos-barcelona.jpeg",
    raw_date: "2025-12-04",
  },
  {
    id: "salvadiscos-blackie-friends-sep25",
    date: "26.09.25",
    name: "Blackie & Friends @ Salvadiscos BCN",
    image:
      "img/past_gigs/2025-09-26_salvadiscos-blackie-and-friends_barcelona.jpg",
    raw_date: "2025-09-26",
  },
  {
    id: "amateur-aug25",
    date: "30.08.25",
    name: "Amateur BCN",
    image: "img/past_gigs/2025-08-30_amateur-vinyl-sessions_barcelona.jpg",
    raw_date: "2025-08-30",
  },
  {
    id: "salvadiscos-blackie-friends-jun25",
    date: "268.06.25",
    name: "Salvadiscos BCN",
    image:
      "img/past_gigs/2025-06-08_salvadiscos-blackie-and-friends_barcelona.jpg",
    raw_date: "2025-26-08",
  },
  {
    id: "cafe-berlin-manu-desrets",
    date: "26.04.25",
    name: "Pampa W/ Manu Desrets @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2025-04-26_cafe-berlin-manu-desrets_madrid.jpg",
    raw_date: "2025-04-26",
  },
  {
    id: "salvadiscos-schedule-mar25",
    date: "01.03.25",
    name: "Salvadiscos BCN",
    image: "img/past_gigs/2025-03-01_salvadiscos-schedule_barcelona.jpg",
    raw_date: "2025-03-01",
  },
  {
    id: "amateur-feb25",
    date: "26.02.25",
    name: "Amateur BCN",
    image: "img/past_gigs/2025-02-26_amateur-vinyl-sessions_barcelona.jpg",
    raw_date: "2025-02-26",
  },
  {
    id: "salvadiscos-capdany-dec24",
    date: "31.12.24",
    name: "Cap d'Any @ Salvadiscos BCN",
    image: "img/past_gigs/2024-12-31_salvadiscos-cap-d-any_barcelona.jpg",
    raw_date: "2024-12-31",
  },
  {
    id: "cafe-berlin-blend-nov24",
    date: "30.11.24",
    name: "Blend @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2024-11-30_cafe-berlin-blend_madrid.jpg",
    raw_date: "2024-11-30",
  },
  {
    id: "curtis-bcn",
    date: "06.07.24",
    name: "Beats & Rhymes & Life @ Curtis BCN",
    image: "img/past_gigs/2024-07-06_curtis-bcn_barcelona.jpg",
    raw_date: "2024-07-06",
  },
  {
    id: "josealfredo-aug23",
    date: "31.08.23",
    name: "Josealfredo",
    image: "img/past_gigs/2023-08-31_josealfredo_madrid.jpg",
    raw_date: "2023-08-31",
  },
  {
    id: "berlin-club-all-night-long",
    date: "01.08.19",
    name: "All Night Long @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2019-08-01_berlin-club-all-night-long_madrid.jpg",
    raw_date: "2019-08-01",
  },
  {
    id: "berlin-club-hugo-lx",
    date: "18.04.19",
    name: "W/ Hugo Lx @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2019-04-18_berlin-club-hugo-lx_madrid.jpg",
    raw_date: "2019-04-18",
  },
  {
    id: "berlin-club-nochevieja-dec18",
    date: "31.12.18",
    name: "Nochevieja @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2018-12-31_berlin-club-nochevieja_madrid.jpg",
    raw_date: "2018-12-31",
  },
  {
    id: "berlin-club-switch-materia-sep18",
    date: "27.09.18",
    name: "Switch @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2018-09-27_berlin-club-switch-materia_madrid.jpg",
    raw_date: "2018-09-27",
  },
  {
    id: "killtheparty-sep18",
    date: "15.09.18",
    name: "Kill The Party @ Duna Bar",
    image: "img/past_gigs/2018-09-15_kill-the-party-duna-bar_barcelona.jpg",
    raw_date: "2018-09-15",
  },
  {
    id: "cafe-pavon-san-cayetano-aug18",
    date: "01.08.18",
    name: "Caf\u00e9 Pav\u00f3n",
    image: "img/past_gigs/2018-08-01_cafe-pavon-san-cayetano_madrid.jpg",
    raw_date: "2018-08-01",
  },
  {
    id: "past-gig-55",
    date: "14.07.18",
    name: "Natural Reserve @ Calabazas Bar",
    image: "img/past_gigs/2018-05-05_past-gig-55.jpg",
    raw_date: "2018-07-14",
  },
  {
    id: "past-gig-55-a",
    date: "13.07.18",
    name: "Natural Reserve @ Calabazas Bar",
    image:
      "img/past_gigs/2018-01-01_37067131_2111061522444155_5903142281577234432_n.jpg",
    raw_date: "2018-07-13",
  },
  {
    id: "el-intruso",
    date: "25.05.18",
    name: "El Intruso",
    image: "img/past_gigs/2018-05-25_el-intruso.jpg",
    raw_date: "2018-05-25",
  },
  {
    id: "past-gig-58",
    date: "20.05.18",
    name: "San Lorenzo @ Pajaritos Mojados",
    image: "img/past_gigs/2018-05-20_past-gig-58.jpg",
    raw_date: "2018-05-20",
  },
  {
    id: "past-gig-57",
    date: "15.05.18",
    name: "San Cayetano @ Caf\u00e9 Pav\u00f3n",
    image: "img/past_gigs/2018-05-15_past-gig-57.jpg",
    raw_date: "2018-05-15",
  },
  {
    id: "past-gig-56",
    date: "10.05.18",
    name: "Materia w/ Andrea Dalmas @ Bclub",
    image: "img/past_gigs/2018-05-10_past-gig-56.jpg",
    raw_date: "2018-05-10",
  },
  {
    id: "past-gig-54",
    date: "01.05.18",
    name: "Black Magic Sounds @ Marula Caf\u00e9",
    image: "img/past_gigs/2018-05-01_past-gig-54.jpg",
    raw_date: "2018-05-01",
  },
  {
    id: "past-gig-53",
    date: "26.04.18",
    name: "Areia Bar",
    image: "img/past_gigs/2018-04-26_past-gig-53.jpg",
    raw_date: "2018-04-26",
  },
  {
    id: "past-gig-52",
    date: "21.04.18",
    name: "Chineurs @ Clamores",
    image: "img/past_gigs/2018-04-21_past-gig-52.jpg",
    raw_date: "2018-04-21",
  },
  {
    id: "past-gig-51",
    date: "16.04.18",
    name: "Areia Bar",
    image: "img/past_gigs/2018-04-16_past-gig-51.jpg",
    raw_date: "2018-04-16",
  },
  {
    id: "josealfredo-meets-jagermeister",
    date: "12.04.18",
    name: "Josealfredo Meets Jagermeister",
    image: "img/past_gigs/2018-04-12_josealfredo-meets-jagermeister.jpeg",
    raw_date: "2018-04-12",
  },
  {
    id: "past-gig-49",
    date: "01.04.18",
    name: "Bclub Schedule",
    image: "img/past_gigs/2018-04-01_past-gig-49.jpeg",
    raw_date: "2018-04-01",
  },
  {
    id: "past-gig-48",
    date: "21.03.18",
    name: "Bclub 6 Year Anniversary",
    image: "img/past_gigs/2018-03-21_past-gig-48.jpg",
    raw_date: "2018-03-21",
  },
  {
    id: "past-gig-47",
    date: "10.03.18",
    name: "Club Sub Rosa @ Sala El Sol",
    image: "img/past_gigs/2018-03-10_past-gig-47.jpg",
    raw_date: "2018-03-10",
  },
  {
    id: "past-gig-46",
    date: "28.02.18",
    name: "Bclub 6 Year Anniversary",
    image: "img/past_gigs/2018-02-28_past-gig-46.jpg",
    raw_date: "2018-02-28",
  },
  {
    id: "past-gig-45",
    date: "17.02.18",
    name: "Hauz & Friends @ Taboo",
    image: "img/past_gigs/2018-02-17_past-gig-45.jpg",
    raw_date: "2018-02-17",
  },
  {
    id: "past-gig-44",
    date: "06.02.18",
    name: "Black Radio @ Hotel ME Madrid",
    image: "img/past_gigs/2018-02-06_past-gig-44.jpg",
    raw_date: "2018-02-06",
  },
  {
    id: "past-gig-43",
    date: "27.01.18",
    name: "San Cayetano @ Caf\u00e9 Pav\u00f3n",
    image: "img/past_gigs/2018-01-27_past-gig-43.jpg",
    raw_date: "2018-01-27",
  },
  {
    id: "past-gig-42",
    date: "16.01.18",
    name: "Berlin Club w/ Folamour",
    image: "img/past_gigs/2018-01-16_past-gig-42.jpg",
    raw_date: "2018-01-16",
  },
  {
    id: "past-gig-41",
    date: "05.01.18",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2018-01-05_past-gig-41.jpg",
    raw_date: "2018-01-05",
  },
  {
    id: "18423689",
    date: "01.01.18",
    name: "Berlin Family w/ Wagoon Cookin DJs",
    image:
      "img/past_gigs/2018-01-01_18423689_1683438338626711_7415860982680073496_n.jpg",
    raw_date: "2018-01-01",
  },
  {
    id: "41550629",
    date: "02.04.18",
    name: "Materia Schedule @ Berlin Club",
    image:
      "img/past_gigs/2018-01-01_41550629_818099541859861_7395391769346378908_n.jpg",
    raw_date: "2018-04-02",
  },
  {
    id: "46775756",
    date: "14.02.18",
    name: "Materia @ Switch Club",
    image:
      "img/past_gigs/2018-01-01_46775756_2036995626393687_1587439640808329470_n.jpg",
    raw_date: "2018-02-14",
  },
  {
    id: "past-gig-40",
    date: "25.12.17",
    name: "Nochevieja @ Club Caf\u00e9 Berlin",
    image: "img/past_gigs/2017-12-25_past-gig-40.jpg",
    raw_date: "2017-12-25",
  },
  {
    id: "phoenix-bar-disco-house",
    date: "21.12.17",
    name: "Phoenix Bar Disco House",
    image: "img/past_gigs/2017-12-21_phoenix-bar-disco-house.jpg",
    raw_date: "2017-12-21",
  },
  {
    id: "past-gig-38",
    date: "04.12.17",
    name: "Berlin Club Schedule: NYE Party",
    image: "img/past_gigs/2017-12-04_past-gig-38.jpg",
    raw_date: "2017-12-04",
  },
  {
    id: "past-gig-37",
    date: "23.11.17",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2017-11-23_past-gig-37.jpg",
    raw_date: "2017-11-23",
  },
  {
    id: "past-gig-36",
    date: "13.11.17",
    name: "Ginger Sounds @ Areia Bar",
    image: "img/past_gigs/2017-11-13_past-gig-36.jpg",
    raw_date: "2017-11-13",
  },
  {
    id: "past-gig-35",
    date: "02.11.17",
    name: "Leven @ Clamores",
    image: "img/past_gigs/2017-11-02_past-gig-35.jpg",
    raw_date: "2017-11-02",
  },
  {
    id: "past-gig-34",
    date: "22.10.17",
    name: "Dance to the Groove @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2017-10-22_past-gig-34.jpg",
    raw_date: "2017-10-22",
  },
  {
    id: "past-gig-33",
    date: "11.10.17",
    name: "Dance to the Groove @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2017-10-11_past-gig-33.jpeg",
    raw_date: "2017-10-11",
  },
  {
    id: "josealfredo-aniversario-oct17",
    date: "04.10.17",
    name: "Josealfredo 11 Aniversario",
    image: "img/past_gigs/2017-10-04_josealfredo-aniversario_madrid.jpg",
    raw_date: "2017-10-04",
  },
  {
    id: "past-gig-32",
    date: "01.10.17",
    name: "El Intruso",
    image: "img/past_gigs/2017-10-01_past-gig-32.jpeg",
    raw_date: "2017-10-01",
  },
  {
    id: "past-gig-31",
    date: "20.09.17",
    name: "Dance to the Groove @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2017-09-20_past-gig-31.jpg",
    raw_date: "2017-09-20",
  },
  {
    id: "killtheparty-sep17",
    date: "16.09.17",
    name: "Kill The Party @ Duna Bar",
    image: "img/past_gigs/2017-09-16_kill-the-party-duna-bar_barcelona.jpg",
    raw_date: "2017-09-16",
  },
  {
    id: "phoenix-bar-guiri-falibene",
    date: "14.09.17",
    name: "Phoenix Bar w/ Guiri",
    image: "img/past_gigs/2017-09-14_phoenix-bar-guiri-falibene.jpg",
    raw_date: "2017-09-14",
  },
  {
    id: "past-gig-30",
    date: "09.09.17",
    name: "Belin Caf\u00e9 Schedule",
    image: "img/past_gigs/2017-09-09_past-gig-30.jpg",
    raw_date: "2017-09-09",
  },
  {
    id: "terraza-atenas-hauz-sep17",
    date: "09.09.17",
    name: "Hauz & Friends @ Terraza Atenas",
    image: "img/past_gigs/2017-09-09_terraza-atenas-hauz_madrid.jpg",
    raw_date: "2017-09-09",
  },
  {
    id: "past-gig-29",
    date: "30.08.17",
    name: "Hauz & Friends @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2017-08-30_past-gig-29.jpg",
    raw_date: "2017-08-30",
  },
  {
    id: "past-gig-28",
    date: "19.08.17",
    name: "Hauz w/ Guiri @ Taboo",
    image: "img/past_gigs/2017-08-19_past-gig-28.jpg",
    raw_date: "2017-08-19",
  },
  {
    id: "past-gig-27",
    date: "08.08.17",
    name: "Berlin Family w/ Sandro Bianchi",
    image: "img/past_gigs/2017-08-08_past-gig-27.jpg",
    raw_date: "2017-08-08",
  },
  {
    id: "past-gig-26",
    date: "29.07.17",
    name: "Berlin Family w/ Guiri & Marco Tegui",
    image: "img/past_gigs/2017-07-29_past-gig-26.png",
    raw_date: "2017-07-29",
  },
  {
    id: "past-gig-25",
    date: "18.07.17",
    name: "Hauz w/ Guiri @ Taboo",
    image: "img/past_gigs/2017-07-18_past-gig-25.jpg",
    raw_date: "2017-07-18",
  },
  {
    id: "past-gig-24",
    date: "07.07.17",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2017-07-07_past-gig-24.jpg",
    raw_date: "2017-07-07",
  },
  {
    id: "past-gig-23",
    date: "26.06.17",
    name: "Berlin Family Schedule",
    image: "img/past_gigs/2017-06-26_past-gig-23.jpeg",
    raw_date: "2017-06-26",
  },
  {
    id: "taboo-future-funk-guiri-falibene",
    date: "17.06.17",
    name: "Taboo Future Funk w/ Guiri",
    image: "img/past_gigs/2017-06-17_taboo-future-funk-guiri-falibene.jpg",
    raw_date: "2017-06-17",
  },
  {
    id: "past-gig-21",
    date: "05.06.17",
    name: "Hauz w/ Guiri @ Taboo",
    image: "img/past_gigs/2017-06-05_past-gig-21.jpeg",
    raw_date: "2017-06-05",
  },
  {
    id: "past-gig-20",
    date: "25.05.17",
    name: "Moroder Club Future Funk",
    image: "img/past_gigs/2017-05-25_past-gig-20.jpg",
    raw_date: "2017-05-25",
  },
  {
    id: "past-gig-19",
    date: "15.05.17",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2017-05-15_past-gig-19.jpeg",
    raw_date: "2017-05-15",
  },
  {
    id: "past-gig-18",
    date: "04.05.17",
    name: "Taboo Future Funk",
    image: "img/past_gigs/2017-05-04_past-gig-18.jpeg",
    raw_date: "2017-05-04",
  },
  {
    id: "past-gig-16",
    date: "12.04.17",
    name: "Caf\u00e9 La Palma Future Funk",
    image: "img/past_gigs/2017-04-12_past-gig-16.jpg",
    raw_date: "2017-04-12",
  },
  {
    id: "taboo-future-funk",
    date: "12.04.17",
    name: "Taboo Future Funk",
    image: "img/past_gigs/2017-04-12_taboo-future-funk.jpeg",
    raw_date: "2017-04-12",
  },
  {
    id: "cambolio",
    date: "25.03.17",
    name: "Cambolio",
    image: "img/past_gigs/2017-03-25_cambolio.jpg",
    raw_date: "2017-03-25",
  },
  {
    id: "past-gig-14",
    date: "22.03.17",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2017-03-22_past-gig-14.jpeg",
    raw_date: "2017-03-22",
  },
  {
    id: "past-gig-13",
    date: "11.03.17",
    name: "Berlin Club w/ Guiri",
    image: "img/past_gigs/2017-03-11_past-gig-13.jpeg",
    raw_date: "2017-03-11",
  },
  {
    id: "past-gig-12",
    date: "01.03.17",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2017-03-01_past-gig-12.jpeg",
    raw_date: "2017-03-01",
  },
  {
    id: "berlin-club-past-event",
    date: "18.02.17",
    name: "Berlin Club w/ Nacho Larache",
    image: "img/past_gigs/2017-02-18_berlin-club-past-event.jpeg",
    raw_date: "2017-02-18",
  },
  {
    id: "berlin-club-past-event",
    date: "07.02.17",
    name: "Berlin Club w/ S-Brid",
    image: "img/past_gigs/2017-02-07_berlin-club-past-event.jpeg",
    raw_date: "2017-02-07",
  },
  {
    id: "silken-puerta-america",
    date: "28.01.17",
    name: "Silken Puerta America",
    image: "img/past_gigs/2017-01-28_silken-puerta-america.jpeg",
    raw_date: "2017-01-28",
  },
  {
    id: "berlin-club-schedule",
    date: "12.01.17",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2017-01-12_berlin-club-schedule.jpeg",
    raw_date: "2017-01-12",
  },
  {
    id: "josealfredo-nochevieja",
    date: "31.12.16",
    name: "Josealfredo Nochevieja",
    image: "img/past_gigs/2016-12-31_josealfredo-nochevieja.jpeg",
    raw_date: "2016-12-31",
  },
  {
    id: "berlin-club-schedule",
    date: "01.12.16",
    name: "Berlin Club All Night Long",
    image: "img/past_gigs/2016-12-01_berlin-club-schedule.jpeg",
    raw_date: "2016-12-01",
  },
  {
    id: "berlin-club-tomas-saenz",
    date: "10.11.16",
    name: "Berlin Club w/ Tomas Saenz",
    image: "img/past_gigs/2016-11-10_berlin-club-tomas-saenz.jpeg",
    raw_date: "2016-11-10",
  },
  {
    id: "berlin-club-manu-desrets",
    date: "22.09.16",
    name: "Berlin Club w/ Manu Desrets",
    image: "img/past_gigs/2016-09-22_berlin-club-manu-desrets.jpeg",
    raw_date: "2016-09-22",
  },
  {
    id: "berlin-club-schedule",
    date: "01.09.16",
    name: "Berlin Club Schedule",
    image: "img/past_gigs/2016-09-01_berlin-club-schedule.jpeg",
    raw_date: "2016-09-01",
  },
  {
    id: "killtheparty-aug15",
    date: "29.08.15",
    name: "Kill The Party V",
    image: "img/past_gigs/2015-08-29_kill-the-party-club-progreso_alsina.jpg",
    raw_date: "2015-08-29",
  },
  {
    id: "killtheparty-oct14",
    date: "11.10.14",
    name: "Kill The Party IV",
    image:
      "img/past_gigs/2014-10-11_kill-the-party-mamba-night-bar_san-antonio-de-areco.jpg",
    raw_date: "2014-10-11",
  },
  {
    id: "killtheparty-sep14",
    date: "06.09.14",
    name: "Kill The Party III",
    image:
      "img/past_gigs/2014-09-06_kill-the-party-mamba-night-bar_san-antonio-de-areco.jpg",
    raw_date: "2014-09-06",
  },
  {
    id: "cafe-berlin-first-time-sep13",
    date: "28.09.13",
    name: "First Time @ Caf\u00e9 Berlin",
    image: "img/past_gigs/2013-09-28_cafe-berlin-first-time_madrid.jpg",
    raw_date: "2013-09-28",
  },
  {
    id: "killtheparty-jul13",
    date: "13.07.13",
    name: "Kill The Party II",
    image: "img/past_gigs/2013-07-13_kill-the-party_san-antonio-de-areco.jpg",
    raw_date: "2013-07-13",
  },
];
